import _ from 'lodash';

export const debounce = (callback, delayTime = 500) => {
  const debounce = {
    internalDebounce: _.debounce(callback, delayTime),
    cancel() {
      if (debounce.internalDebounce) debounce.internalDebounce.cancel();
    },
    execute() {
      debounce.internalDebounce();
      return this;
    },
  };
  return debounce;
};
